export default "__VITE_ASSET__c$SREbjM__"